import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import KeyData from "@/components/KeyData";
import CelestialLoader from "@/components/CelestialLoader";
import ResonanceAvatar from "@/components/ResonanceAvatar";

export default function RevealResonance() {
  const navigate = useNavigate();
  const [r, setR] = useState(null);

  useEffect(() => {
    api.post("/reveal/generate").then(res => setR(res.data.resonance)).catch(() => {});
  }, []);

  if (!r) return <CelestialLoader />;

  return (
    <div className="min-h-screen px-6 py-10 max-w-md mx-auto" style={{ color: "var(--vedari-ink)" }}>
      <p className="text-caption tracking-[0.25em] uppercase" style={{ color: "var(--vedari-gold)" }} data-testid="resonance-eyebrow">
        Your Resonance
      </p>
      <h1 className="font-display text-3xl mt-3 leading-tight">Your chapter resonates with…</h1>

      <div className="vedari-card mt-8">
        <div className="flex flex-col items-center text-center">
          <div className="mb-4">
            <ResonanceAvatar name={r.name} />
          </div>
          <h2 className="font-display text-h1" data-testid="resonance-name">
            <KeyData>{r.name}</KeyData>
          </h2>
          <p className="text-caption mt-1" style={{ color: "var(--vedari-ink-soft)" }}>
            <KeyData>{r.lifespan}</KeyData> · {r.domain}
          </p>
          <p className="text-body mt-5 leading-relaxed" style={{ color: "var(--vedari-ink-soft)" }}>{r.bio}</p>
        </div>

        <div className="mt-7 pt-6" style={{ borderTop: "1px solid var(--vedari-divider)" }}>
          <p className="text-caption uppercase tracking-wider mb-3" style={{ color: "var(--vedari-gold)" }}>What you share</p>
          <ul className="space-y-3">
            {r.similarities.map((s, i) => (
              <li key={i} className="text-body leading-relaxed flex gap-3">
                <span className="key-data shrink-0 mt-0.5">{String(i+1).padStart(2, "0")}</span>
                <span>{s}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="mt-6 pt-5" style={{ borderTop: "1px solid var(--vedari-divider)" }}>
          <p className="text-caption uppercase tracking-wider mb-3" style={{ color: "var(--vedari-gold)" }}>What this teaches your journey</p>
          <p className="text-body-lg leading-relaxed font-serif" style={{ color: "var(--vedari-ink)" }}>{r.teaching}</p>
        </div>
      </div>

      <p className="text-body-sm mt-6 text-center font-serif italic" style={{ color: "var(--vedari-ink-soft)" }}>
        Two more resonances will reveal as you walk.
      </p>

      <button onClick={() => navigate("/reveal/mission")} className="vedari-btn-primary w-full mt-8" data-testid="resonance-continue-btn">
        Continue
      </button>
    </div>
  );
}
